import type { FC } from 'react'

import { Sparkles } from 'lucide-react'
import { cn } from '@/lib/utils'

export const matchTone = (score: number) => {
    if (score >= 75) return { label: 'Strong fit', text: 'text-success', bg: 'bg-success/12', bar: 'bg-success', stroke: 'var(--success)' }
    if (score >= 55) return { label: 'Good fit', text: 'text-primary', bg: 'bg-primary/10', bar: 'bg-primary', stroke: 'var(--primary)' }
    if (score >= 35) return { label: 'Partial fit', text: 'text-warning-foreground', bg: 'bg-warning/15', bar: 'bg-warning', stroke: 'var(--warning)' }
    return { label: 'Low fit', text: 'text-destructive', bg: 'bg-destructive/10', bar: 'bg-destructive', stroke: 'var(--destructive)' }
}

interface MatchBadgeProps {
    score: number
    className?: string
    showLabel?: boolean
}

export const MatchBadge: FC<MatchBadgeProps> = ({ score, className, showLabel }) => {
    const tone = matchTone(score)

    return (
        <span
            className={cn('inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-bold whitespace-nowrap', tone.bg, tone.text, className)}
            title={`${tone.label}: ${score}% match with your resume`}
        >
            <Sparkles className='size-3.5' />
            {score}% match
            {showLabel && <span className='font-medium'>· {tone.label}</span>}
        </span>
    )
}
